import { render, staticRenderFns } from "./UpsertProductStatusTypeModal.vue?vue&type=template&id=625f59e0&"
import script from "./UpsertProductStatusTypeModal.vue?vue&type=script&lang=ts&"
export * from "./UpsertProductStatusTypeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports